import { Link } from '@inertiajs/react';
import React from 'react';

interface Post {
  title: string;
  excerpt: string;
  imageUrl: string;
  author: string;
  authorAvatar: string;
  date: string;
  content: string;
}

export const BlogPostCard: React.FC<{
  post: Post;
}> = ({ post }) => (
  <div className='h-full bg-card rounded-lg shadow-md overflow-hidden border border-border hover:border-primary hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 flex flex-col'>
    <Link href='/blog_details' data={{ post }} className='flex flex-col flex-grow'>
      <img src={post.imageUrl} alt={post.title} className='w-full h-56 object-cover' />
      <div className='p-6 flex flex-col flex-grow'>
        <h3 className='text-xl font-bold text-card-foreground mb-3 font-heading'>{post.title}</h3>
        <p className='text-muted-foreground text-sm flex-grow'>{post.excerpt}</p>
        <div className='mt-6 pt-4 border-t border-border flex items-center justify-between'>
          <div className='flex items-center'>
            <img src={post.authorAvatar} alt={post.author} className='w-10 h-10 rounded-full mr-3' />
            <div>
              <p className='font-semibold text-foreground text-sm'>{post.author}</p>
              <p className='text-muted-foreground text-xs'>{post.date}</p>
            </div>
          </div>
          <div className='font-semibold text-primary hover:text-primary/80 transition-colors'>Read More &rarr;</div>
        </div>
      </div>
    </Link>
  </div>
);
